export function checkStatus(res: Response) {
  if (res.status >= 200 && res.status < 300) {
    return res;
  } else {
    throw res.statusText;
  }
}
